import { subStatusToCustomerStatus } from '@/modules/customer/utils/status'
import { listSubscriptions } from './subscriptionService'
import type { SubscriptionItem } from '../types'

export type SubscriptionStats = {
  total: number
  approved: number
  pending: number
  past_due: number
  inactive: number
  trial: number
}

export async function getSubscriptionStats(): Promise<SubscriptionStats> {
  try {
    let page = 1
    const pageSize = 100
    let approved = 0
    let pending = 0
    let past_due = 0
    let inactive = 0
    let trial = 0
    let totalAccounts = 0

    // Usa a mesma agregação da listagem admin (Edge Function admin-subscription-list)
    // Pagina até cobrir o total de contas retornado.
    // eslint-disable-next-line no-constant-condition
    while (true) {
      const { items, total } = await listSubscriptions({ page, pageSize, status: '', search: '' })
      if (page === 1) totalAccounts = total
      if (!items.length) break

      for (const s of items as SubscriptionItem[]) {
        const raw = String(s.status || '').toLowerCase()
        const customerStatus = subStatusToCustomerStatus(raw)

        if (customerStatus === 'ativo') approved++
        else if (customerStatus === 'pendente') pending++
        else if (customerStatus === 'suspenso') past_due++
        else if (customerStatus === 'inativo') inactive++

        const planId = String(s.plan_id || '').toLowerCase()
        const isTrial =
          !!s.is_trial ||
          raw === 'trialing'

        if (isTrial) trial++
      }

      if (page * pageSize >= total) break
      page += 1
    }

    const total = totalAccounts || (approved + pending + past_due + inactive)
    return { total, approved, pending, past_due, inactive, trial }
  } catch {
    return { total: 0, approved: 0, pending: 0, past_due: 0, inactive: 0, trial: 0 }
  }
}
